/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Surface from 'components/Surface';
import { BoldText } from 'components/Text';
import Colors from 'constants/Colors';
import { mediaHelper} from 'utils';

export const Container = styled(Surface)`
  position: relative;
  padding: 16px;
  margin: auto !important;
  
  ${({ hasTitle }) =>
    hasTitle &&
    css`
      padding-top: 75px;
    `}
    
  ${mediaHelper.xxs`
    margin: 0px 0px 15px 0px !important;
  `}  

  ${mediaHelper.xs`
   margin: 0px 0px 15px 0px !important;
  `}

  ${mediaHelper.sm`
   margin: 0px 0px 15px 0px !important;
  `}

  ${mediaHelper.md`
   margin-top: 10px !important;
  `}
`;

export const CardHeader = styled(BoldText)`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 16px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: ${Colors.GRAY[5]};
  color: ${Colors.Alpha(Colors.PRIMARY, 0.7)};
  font-size: 18px;
`;
